import React, { useEffect, useState } from 'react';
import { api, API_BASE } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Download, FileText, Table2 } from 'lucide-react';
import { toast } from 'sonner';
import { usePeriod } from '@/context/PeriodContext';
import { MONTH_NAMES, fmtMXN, STATUS_LABEL } from '@/lib/format';
import PeriodPicker from '@/components/PeriodPicker';

export default function Reports() {
  const { year, month } = usePeriod();
  const [periods, setPeriods] = useState([]);
  const [current, setCurrent] = useState(null);

  const load = async () => {
    const all = await api.get('/periods');
    setPeriods(all.data);
    const p = await api.get(`/periods/lookup/${year}/${month}`);
    const s = await api.get(`/periods/${p.data.id}/summary`);
    setCurrent(s.data);
  };
  useEffect(() => { load(); }, [year, month]);

  const download = async (periodId, kind) => {
    try {
      const r = await api.get(`/periods/${periodId}/report.${kind}`, { responseType: 'blob' });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a'); a.href = url; a.download = `resico-${periodId}.${kind}`; a.click();
      URL.revokeObjectURL(url);
    } catch (e) { toast.error('No se pudo generar el reporte'); }
  };

  return (
    <div className="space-y-5">
      <PeriodPicker/>
      <div>
        <h2 className="font-display text-2xl font-bold tracking-tight">Reportes</h2>
        <p className="text-xs text-muted-foreground mt-0.5">Descarga PDF o CSV</p>
      </div>

      {current && (
        <Card className="p-4 border-border rounded-xl bg-primary/5 border-primary/20">
          <p className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground font-bold">Periodo actual</p>
          <p className="font-display text-xl font-extrabold tracking-tight mt-1">{MONTH_NAMES[current.period.month-1]} {current.period.year}</p>
          <p className="text-sm text-muted-foreground mt-1">Ingresos: <span className="font-semibold num text-foreground">{fmtMXN(current.summary.ingresos_totales)}</span> · ISR est.: <span className="font-semibold num text-foreground">{fmtMXN(current.summary.isr_estimado)}</span></p>
          <div className="grid grid-cols-2 gap-2 mt-4">
            <Button data-testid="dl-pdf" onClick={() => download(current.period.id, 'pdf')} className="h-11 rounded-full"><FileText className="h-4 w-4 mr-2"/> PDF</Button>
            <Button data-testid="dl-csv" onClick={() => download(current.period.id, 'csv')} variant="outline" className="h-11 rounded-full"><Table2 className="h-4 w-4 mr-2"/> CSV</Button>
          </div>
        </Card>
      )}

      <Card className="p-4 border-border rounded-xl">
        <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-muted-foreground mb-3">Todos los periodos</p>
        {periods.length === 0 ? <p className="text-sm text-muted-foreground">Sin periodos aún.</p> : (
          <div className="space-y-2">
            {periods.map(p => (
              <div key={p.id} data-testid={`report-${p.year}-${p.month}`} className="flex items-center justify-between border border-border rounded-lg p-3">
                <div>
                  <p className="font-medium text-sm">{MONTH_NAMES[p.month-1]} {p.year}</p>
                  <p className="text-xs text-muted-foreground">{STATUS_LABEL[p.status]}{p.locked ? ' · Bloqueado' : ''}</p>
                </div>
                <div className="flex gap-1">
                  <button data-testid={`dl-pdf-${p.year}-${p.month}`} onClick={() => download(p.id, 'pdf')} className="h-9 w-9 rounded-full border border-border flex items-center justify-center hover:bg-secondary"><FileText className="h-4 w-4"/></button>
                  <button data-testid={`dl-csv-${p.year}-${p.month}`} onClick={() => download(p.id, 'csv')} className="h-9 w-9 rounded-full border border-border flex items-center justify-center hover:bg-secondary"><Table2 className="h-4 w-4"/></button>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card>
    </div>
  );
}
